import { z } from "zod";

export const inviteUserFormConfig = z.object({
    email: z
        .string({ required_error: "validation.required" })
        .email({ message: "validation.email" }),
});

export type InviteUserFormConfig = z.infer<typeof inviteUserFormConfig>;
